import * as yup from 'yup';

export const validateEmails = (emails) => {
  if (!emails) return [];
  
  const invalidEmails = emails.filter((email) => !isValidEmail(email));
  return invalidEmails;
};

export const isValidEmail = (email) => {
  const emailSchema = yup.string().email();
  return emailSchema.isValidSync(email);
};

export const formatTextWithVariables = (markup) => {
  return markup
    ?.replace(/{/gi, '<span>{')
    .replace(/}/gi, '}</span>')
    .replace(/\n/gi, '<br />')
    // Format nested lists
    // example: <li>Parent</li><li class="ql-indent-1">Child 1</li><li class="ql-indent-1">Child 2</li>
    // becomes: <li>Parent<ul><li>Child 1</li><li>Child 2</li></ul></li>
    .replace(
      /<li>(.*?)<\/li>((\s*<li class="ql-indent-1">(.*?)<\/li>)+)/g,
      (match, parentContent, childrenGroup) => {
        // Extract all children
        const children = childrenGroup
          .match(/<li class="ql-indent-1">(.*?)<\/li>/g)
          .map(child => child.replace(/<li class="ql-indent-1">(.*?)<\/li>/, '<li>$1</li>'))
          .join(""); // Combine children into a single string
        return `<li>${parentContent}<ul>${children}</ul></li>`;
      }
    );
};